import React, { Component } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Dropzone from 'react-dropzone';

import If from '../../shared/If';
import Box from '../../shared/Box';
import Icon from '../../shared/Icon';
import { ButtonWithHoverAndPress } from '../../shared/Button';
import PodcastSquare from '../PodcastSquare';
import { DEFAULT_IMAGE } from '../../onboarding';
import ImageCropper from '../ImageCropper';
import events from './events';
import styles from './styles.sass';

class ImageUploader extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      uploadedImage: null,
      croppedBlobURL: null,
      showCropper: false,
    };
  }

  handleImageFileDrop = (acceptedFiles, rejectedFiles) => {
    const { onShowCropper } = this.props;
    if (rejectedFiles.length) {
      // TODO (bui): error state
    } else {
      const uploadedImage = acceptedFiles[0];
      this.setState({
        uploadedImage: uploadedImage.preview,
        showCropper: true,
      });
      onShowCropper && onShowCropper();
    }
  };

  handleImageCrop = croppedBlob => {
    this.setState({
      croppedBlobURL: URL.createObjectURL(croppedBlob),
      showCropper: false,
    });
    this.props.onImageLocallyUploaded(croppedBlob);
  };

  handleCancelCrop = evt => {
    this.setState({
      croppedBlobURL: null,
      showCropper: false,
    });
  };

  render() {
    const {
      originalImage: originalImageProp,
      uploadLinkLabel,
      className,
      isCropperInline,
      clickEventName,
      screen,
      altText,
    } = this.props;
    const { uploadedImage, showCropper, croppedBlobURL } = this.state;
    const currentImage = croppedBlobURL || originalImageProp || DEFAULT_IMAGE;
    const isShowingPlaceholderCoverArt = currentImage === DEFAULT_IMAGE;

    return (
      <If
        condition={showCropper}
        elseRender={() => (
          <Dropzone
            data-cy="imageUploaderDropzone"
            className={`${styles.editImageContainer} ${className || ''}`}
            accept="image/*"
            onDrop={this.handleImageFileDrop}
            multiple={false}
            onClick={() => {
              if (clickEventName && screen)
                events.imageUploaderClicked(clickEventName, {
                  location: screen,
                });
            }}
          >
            <Box marginBottom={26} width="100%">
              {isShowingPlaceholderCoverArt ? (
                <Box
                  width={250}
                  height={250}
                  color="#dedfe0"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  dangerouslySetInlineStyle={{ borderRadius: '6px' }}
                >
                  <Box width={113}>
                    <Icon type="anchor_logo" fillColor="white" />
                  </Box>
                </Box>
              ) : (
                <PodcastSquare
                  borderRadius={10}
                  image={currentImage}
                  altText={altText}
                />
              )}
            </Box>
            <ButtonWithHoverAndPress
              typeAttribute="button"
              text={uploadLinkLabel || 'Upload a new cover art image'}
              type="outlined"
              colorTheme="primary"
              size="sm"
              shape="pill"
              isFullWidth
              isEventBubblingAllowed
            />
          </Dropzone>
        )}
        ifRender={() => (
          <If
            condition={isCropperInline}
            ifRender={() => (
              <ImageCropper
                screen={screen}
                imageFile={uploadedImage}
                onCancel={this.handleCancelCrop}
                onImageCrop={this.handleImageCrop}
              />
            )}
            elseRender={() => (
              <Modal show onHide={this.handleCancelImageEdit}>
                <Modal.Header closeButton />
                <Modal.Body className="text-center">
                  <ImageCropper
                    screen={screen}
                    imageFile={uploadedImage}
                    onCancel={this.handleCancelCrop}
                    onImageCrop={this.handleImageCrop}
                  />
                </Modal.Body>
              </Modal>
            )}
          />
        )}
      />
    );
  }
}

export default ImageUploader;
